export default __webpack_public_path__ + "2476c1d77fe8e726c1faaac28b51b381.png";